'use strict';

angular.module('webAgro1App').controller('HistoricoAplicacoesCtrl',

  //eslint-disable-next-line max-params,max-lines-per-function
  function($filter, $rootScope, $scope, $q, filterFilter, $timeout,
    LoadingService, MessagesService, PeriodSelectService, HistoricosService,
    AplicacoesService, RecomendacoesService, $http, MapaService,
    GoogleMapsService, PeriodosService, DrawPolygonsObjectService,
    $route, $routeParams, LeafletService, TrackingService, $anchorScroll, DrawPolygonsService,
    DecimalsService) {
    $scope.glebas = $rootScope.currentPropriedade.glebas || [];
    $scope.loadingAplicacoes = false;
    $scope.showWeather = true;
    $scope.statusFilter = { integrado: false, erro: false, pendente: false };

    let hasPage = true;
    let inProgress = false;
    let requestId = 0;
    let percentualRecomendadoAplicado;
    let activePolygons = [];

    const initializeVariables = function() {
      $scope.applicationsFilters.page = 1;
      hasPage = true;
      inProgress = false;
      requestId += 1;
      $scope.applications = [];
      $scope.$emit('setOutrasLegendas', Object.values(LEGENDAS_APLICACOES));
      percentualRecomendadoAplicado =
        $rootScope.parametros.percentual_recomendado_aplicado ||
        PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO;
    };


    const setValoresComBaseNoHistorico = function() {
      let filteredPeriod;

      if ($routeParams.historyDate || $routeParams.date) {
        filteredPeriod = HistoricosService.getFilteredPeriod();
        $scope.applicationsFilters.dataInicial = filteredPeriod.dataInicial;
        $scope.applicationsFilters.dataFinal = filteredPeriod.dataFinal;
        $scope.period = filteredPeriod.periodo;
      }
      if ($routeParams.activeGleba) {
        $scope.applicationsFilters.gleba = filterFilter($scope.glebas, {
          id: +$routeParams.activeGleba
        }, true)[0];
      }
    };

    const initialize = function() {
      $scope.loadingAplicacoes = true;
      $scope.applicationsFilters = {
        tipo: 'aplicacao'
      };

      $rootScope.initialize.then(rootScopeInitialize, $rootScope.errorRootInitialize);
    };

    function rootScopeInitialize() {
      const shouldLoadApplications = true;
      const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
      if (selectedGleba) {
        $scope.applicationsFilters.gleba = $scope.$root.currentPropriedade.glebas
          .find((gleba) => gleba.id === +selectedGleba);
      }
      initializeVariables();
      $scope.resetPeriodsFilter();
      $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
      setValoresComBaseNoHistorico();

      $scope.loadingGrupoInsumo = true;

      PeriodosService.list().then(function(result) {
        $scope.epocas = result.data;
      }, function(error) {
        console.error('Erro ao listar períodos das culturas', error);
      });

      HistoricosService.listGruposInsumos().then(function(data) {
        $scope.filtroGruposInsumos = data.data || [];
      }, function() {
        MessagesService.alert('Não foi possível consultar os dados.');
      })
        .finally(function() {
          $scope.loadingGrupoInsumo = false;
        });

      if (shouldLoadApplications) {
        $scope.getApplications();
      }
    }

    $scope.$on('pulverizacaoActivate', initialize);

    $scope.$on('pulverizacaoDeactivate', clear);

    $scope.$on('applications_close', clear);

    function clear() {
      $scope.$emit('setOutrasLegendas', null);
      $scope.$emit('setCustomGlebaPolygonOptions', null);
      clearMapPolygons();
      closeApplicationsAreaVisivel();
      $scope.applications = [];
    }

    const getEstadiosCultura = function() {
      $scope.estadios = [];
      $scope.applicationsFilters.estadio = null;

      if ($scope.applicationsFilters.cultura) {
        $scope.loadingEstadio = true;
        HistoricosService.listEstadios($scope.applicationsFilters).then(function(estadios) {
          $scope.estadios = estadios.data || [];
        }, function() {
          MessagesService.alert('Não foi possível buscar os estádios fenológicos.');
        })
          .finally(function() {
            $scope.loadingEstadio = false;
          });
      }
    };

    $scope.getDateFormat = function(date) {
      return $filter('date')(date, DATE_WITHOUT_YEAR_FORMAT);
    };

    $scope.getDurationFromSeconds = function(seconds) {
      const milisecondsMultiplier = 1000;
      const defaultValue = 0;
      return moment.utc(milisecondsMultiplier * (parseInt(seconds) || defaultValue))
        .format('HH:mm:ss');
    };

    $scope.setFilterAttribute = function(attribute, object, event) {
      preventDefault(event);
      initializeVariables();
      $scope.applicationsFilters[attribute] = object;
      if (attribute === 'cultura') {
        getEstadiosCultura();
      } else if (attribute === 'gleba') {
        $route.updateParams({
          activeGleba: object && object.id
        });
      }
      $scope.getApplications();
    };

    $scope.toggleStatusFilter = function(status, event) {
      stopPropagation(event);
      preventDefault(event);
      $scope.statusFilter[status] = !$scope.statusFilter[status];
      initializeVariables();
      $scope.applicationsFilters.status = buildStatusParam($scope.statusFilter);
      $scope.getApplications();
    };

    $scope.getStatusFilterLabel = function() {
      const statusLabels = { integrado: 'Integrado', erro: 'Erro', pendente: 'Pendente' };
      const chaves = Object.keys(statusLabels);
      const selecionadas = chaves.filter((chave) => $scope.statusFilter[chave]);

      if (selecionadas.length === 0 || selecionadas.length === chaves.length) {
        return 'Status';
      }
      return selecionadas.map((chave) => statusLabels[chave]).join(', ');
    };

    function buildStatusParam(statusFilter) {
      const statusParaApi = { integrado: 'finalizado', erro: 'erro', pendente: 'pendente' };
      const selecionadas = Object.keys(statusParaApi).filter((chave) => statusFilter[chave]);
      return selecionadas.length ? selecionadas.map((chave) => statusParaApi[chave]).join(',') : null;
    }

    $scope.openPeriodsFilter = function(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection($scope.period, $scope.applicationsFilters)
        .then(function() {
          $scope.setPeriodo();
        });
    };

    $scope.setPeriodo = function(periodo, event) {
      preventDefault(event);
      initializeVariables();
      if (periodo) {
        $scope.applicationsFilters.dataInicial = periodo.dataInicial;
        $scope.applicationsFilters.dataFinal = periodo.dataFinal;
        $scope.period.periodo = periodo.descricao;
      }
      $scope.getApplications();
    };

    $scope.resetPeriodsFilter = function() {
      $scope.applicationsFilters.dataInicial = null;
      $scope.applicationsFilters.dataFinal = null;
      $scope.period = {
        eventDates: [],
        periodo: ''
      };
    };

    // eslint-disable-next-line max-lines-per-function
    $scope.getApplications = function() {
      if ($rootScope.permissions.pulverizacao.canRead) {
        const hasFilterPage = $scope.applicationsFilters && $scope.applicationsFilters.page;
        if (hasFilterPage && hasPage && !inProgress) {
          $scope.loadingAplicacoes = true;
          inProgress = true;
          const currentRequestId = requestId;

          const error = function() {
            if (currentRequestId === requestId) {
              MessagesService.alert('Não foi possível buscar a lista de Aplicações.');
            }
          };

          const promises = [
            AplicacoesService.list($scope.applicationsFilters)
          ];

          if (!$scope.applications.length) {
            promises.push(
              AplicacoesService.getStatusPulverizacaoGlebas($scope.applicationsFilters)
            );
          }

          $q.all(promises)
            .then((data) => {
              if (currentRequestId === requestId) {
                processLoadedApplications(data);
              }
            }, error)
            .finally(function() {
              if (currentRequestId === requestId) {
                inProgress = false;
                $scope.loadingAplicacoes = false;
              }
            });
        }
      }
    };

    function processLoadedApplications(data) {
      const [firstData] = data || {};
      const dados = firstData.data || [];
      try {
        hasPage = firstData.pages.pagination.next > $scope.applicationsFilters.page;
      } catch (_error) {
        hasPage = false;
      }

      if (dados.length > 0) {
        $scope.applicationsFilters.page++;
        $scope.applications = $scope.applications.concat(dados);
        closeApplicationsAreaVisivel();
        clearMapPolygons();

        openSingleApplication();
      }

      if (data[1]) {
        setGlebasMapOptions(data[1].data || []);
      }
    }

    function openSingleApplication() {
      if ($scope.applications.length === 1) {
        $scope.openApplicationDetail(null, $scope.applications[0]);
      } else if ($routeParams.activeApplication) {
        const app = $scope.applications.find(function(a) {
          return +a.id === +$routeParams.activeApplication;
        });
        if (app) {
          $scope.openApplicationDetail(null, app);
        } else {
          updateRouteParams();
        }
      }
    }

    $scope.openApplicationDetail = function(event, application) {
      if (event) {
        stopPropagation(event);
        preventDefault(event);
      }

      if (!application || !application.id) {
        return;
      }

      clearMapPolygons();
      closeApplicationsAreaVisivel();
      application.openRecommendation = false;
      application.classificacao = {};

      if (!application.open) {
        _openApplication(application);
      } else {
        application.open = false;
        updateRouteParams();
      }
    };

    function _openApplication(application) {
      updateRouteParams(application.id);
      application.loading = true;
      application.allData = {};
      AplicacoesService.get(application.id).then(function(data) {
        application.allData = data.data || {};
        const atributo = application.allData.atributo || {};
        const maquina = atributo.maquina || {};
        const temTanque = atributo.capacidade_tanque > 0;
        application.allData.maquinaDescricao =
          maquina.descricao || (temTanque ? 'Não Cadastrado' : '');
        $anchorScroll($scope.getCardApplicationId(application));
      }, function() {
        MessagesService.alert('Não foi possível consultar a aplicação.');
      })
        .finally(function() {
          application.loading = false;
          application.open = true;
        });
    }

    function updateRouteParams(id = null) {
      $route.updateParams({
        activeApplication: id
      });
    }

    $scope.openRecommendationDetail = function(event, application) {
      stopPropagation(event);
      preventDefault(event);
      if (!application || !application.id || !application.open) {
        return;
      }

      if (!application.openRecommendation) {
        application.openRecommendation = !application.openRecommendation;
        application.recommendation = {};
        setPositionSubCardApplication(application);

        try {
          if (_.get(application, 'allData.atributo.recomendacao_id')) {
            const recomendacaoId = application.allData.atributo.recomendacao_id;
            application.loadingRecommendation = true;
            getRecomendacao(application, recomendacaoId);
          }
        } catch (_error) {
          console.warn('Aplicação não tem recomendação');
        }
      } else {
        application.openRecommendation = !application.openRecommendation;
      }
    };

    function getRecomendacao(application, recomendacaoId) {
      RecomendacoesService.get(recomendacaoId).then(function(data) {
        if (data.data) {
          application.recommendation = data.data;

          application.recommendation.gleba = filterFilter(application.recommendation.glebas, {
            id: application.gleba.id
          }, true)[0];
          setClassificacaoAplicadoRecomendado(application);
        }
      }, function() {
        MessagesService.alert('Não foi possível consultar a recomendação.');
      })
        .finally(function() {
          application.loadingRecommendation = false;
        });
    }

    function setClassificacaoAplicadoRecomendado(application) {
      AplicacoesService
        .setClassificacaoAplicadoRecomendado(application, percentualRecomendadoAplicado);
    }

    $scope.isOpened = function(application) {
      return application.open && application.openRecommendation;
    };

    $scope.getSubCardApplicationId = function(application) {
      return `subcard-application-${application.id}`;
    };

    $scope.getCardApplicationId = function(application) {
      return `application-${application.id}`;
    };

    function setPositionSubCardApplication(application) {
      const card = $(`#${ $scope.getCardApplicationId(application)}`);
      const subCard = $(`#${ $scope.getSubCardApplicationId(application)}`);

      subCard.css({
        'min-height': `${card.height()}px`,
        width: `${card.width()}px`,
        top: `${card.offset().top}px`
      });
    }

    function setGlebasMapOptions(glebasStatus) {
      const styles = $scope.glebas.reduce(function(group, gleba) {
        const status = (glebasStatus[gleba.id] || {}).status;
        group[gleba.id] = leafletOptions((LEGENDAS_APLICACOES[status] || {}).optionsMap ||
          OPTIONS_MAP_DEFAULT_APLICACOES);
        return group;
      }, {});
      $scope.$emit('setCustomGlebaPolygonOptions', styles);

      function leafletOptions(gmOptions) {
        return {
          color: gmOptions.strokeColor,
          opacity: gmOptions.strokeOpacity,
          weight: gmOptions.strokeWeight,
          fillColor: gmOptions.fillColor,
          fillOpacity: gmOptions.fillOpacity
        };
      }
    }

    // FECHA AS RECOMENDAÇÕES ABERTAS
    $timeout(function() {
      $('#list-application-history .panel-group').scroll(function() {
        ($scope.applications || []).forEach(function(application) {
          application.openRecommendation = false;
        });
        $scope.$apply();
      });
    }, 500);

    $scope.remover = function(application) {
      MessagesService.confirm('Deseja realmente excluir a aplicação?').then(function() {
        LoadingService.showLoading();
        AplicacoesService.delete(application.id).then(function() {
          MessagesService.alert('Aplicação excluída com sucesso.');
          $route.reload();
        })
          .catch(function(error) {
            let message = 'Falha ao excluir aplicação';
            if (_.get(error.data, 'message')) {
              message = `${message}: ${error.data.message}`;
            }
            MessagesService.alert(message);
            console.error('Falha ao excluir aplicação', error);
          })
          .finally(LoadingService.hideLoading);
      });
    };

    $scope.edit = function(application) {
      $scope.$emit('activateSidebar', 'editApplication', application);
    };

    $scope.showAreaDemarcada = function(application) {
      if (!application.areaVisivel) {
        application.areaVisivel = true;

        if (application.allData.has_area_demarcada) {
          application.polygons = DrawPolygonsObjectService
            .convertToObject(application.allData.area_demarcada || {}, true)
            .polygons;

          // Utilizado weight pois este polígono é montado pelo leafletjs
          // https://leafletjs.com/reference-1.2.0.html#polygon
          application.polygons.forEach(({ options }) => {
            options.weight = 7;
            options.strokeWeight = 7;
          });

          activePolygons = activePolygons.concat(application.polygons);
          $scope.$emit('addPolygons', application.polygons);
          const map = LeafletService.getMap('propriedade-map');
          map.fitBounds(application.polygons.map(function(polygon) {
            return polygon.getBounds();
          }));
        }
      } else {
        clearMapPolygons();
        application.areaVisivel = false;
      }
    };

    function activeHeatmaps(application) {
      const { polylines } = application;
      if (!polylines.length) {
        return [];
      }

      $route.updateParams({
        heatmaps: 'pulverizacao'
      });
      $scope.$emit('setActiveHeatmaps', {
        heatmaps: [{ ...application, title: 'Aplicação de pulverização visível' }],
        mapType: 'aplicacao'
      });

      const start = polylines[0].coordinate;
      const end = polylines[polylines.length - 1].coordinate;
      const startEndMarkers = MapaService.createStartEndMarkers(start, end);
      $scope.$emit('setMarkers', startEndMarkers);

      renderPolylines(polylines);
    }

    function hideRastro(aplicacao) {
      aplicacao.viewingRastro = false;
      $scope.$emit('clearPolylines');
      $scope.$emit('clearMarkers');
    }

    function clearMap() {
      $scope.$emit('setImageOverlays', []);
      $scope.$emit('setActiveHeatmaps', []);

      setTimeout(() => {
        $route.updateParams({
          heatmaps: null
        });
      }, 0);
    }

    function hideAllRastros() {
      $scope.applications
        .filter((application) => application.viewingRastro)
        .forEach(hideRastro);
    }

    function loadRastroByTracking(application) {
      if (!application.polylines) {
        $scope.$emit('clearHeatMap');
        $http.get(`${ SERVER }v1/aplicacoes/${ application.id }/tracking`)
          .then(function(response) {
            const data = response.data;

            if (data.length > 0) {
              application.polylines = MapaService.getLeafletPolylineWithObject({
                pontos: data,
                faixas: application.allData.faixas_velocidade
              });
              activeHeatmaps(application);
            } else {
              application.polylines = [];
            }
          });
      } else {
        activeHeatmaps(application);
      }
    }

    function processLoadedPolygons(aplicacao) {
      aplicacao.rastro.polygons.forEach((polygon) => {
        polygon.descricao = formatDescricaoHtml(aplicacao);
      });
    }

    function formatDescricaoHtml(aplicacao) {
      const descricao = [];

      if (aplicacao.gleba) {
        descricao.push(aplicacao.gleba.descricao);
      }

      descricao.push(aplicacao.descricao);

      if (aplicacao.rastro.atividade) {
        descricao.push(`Cultura: ${aplicacao.rastro.atividade.descricao}`);
      }

      if (aplicacao.rastro.cultivar) {
        descricao.push(`Cultivar: ${aplicacao.rastro.cultivar.descricao}`);
      }

      return descricao.join('<br>');
    }


    function loadRastro(aplicacao) {
      LoadingService.showLoading();
      aplicacao.rastros = [];

      const promises = aplicacao.allData.area_demarcada_ids.map((areaId) => {
        aplicacao.rastro = {};

        return DrawPolygonsService.get(areaId)
          .then(({ data }) => {
            const polylines = MapaService.getLeafletPolylineWithObject({
              pontos: _.flatMap(data.coordenadas, 'pontos'),
              faixas: data.faixas_velocidade
            });
            aplicacao.rastro = { polygons: polylines };
            processLoadedPolygons(aplicacao);
            const start = aplicacao.rastro.polygons[0].coordinate;
            const end = aplicacao.rastro.polygons[aplicacao.rastro.polygons.length - 1].coordinate;

            aplicacao.startEndMarkers = MapaService.createStartEndMarkers(start, end);
            $scope.$emit('setMarkers', aplicacao.startEndMarkers);
          })
          .catch((error) => {
            console.error(error);
            MessagesService.alert('Erro ao obter rastro da máquina.');
            aplicacao.rastro = [];
          })
          .finally(LoadingService.hideLoading);
      });

      return $q.all(promises);
    }


    $scope.showRastroMaquina = function(aplicacao) {
      if (aplicacao.viewingRastro) {
        $scope.$emit('setActiveHeatmaps', []);
        clearMap();
        return hideRastro(aplicacao);
      }

      hideAllRastros();
      aplicacao.viewingRastro = true;

      if (!aplicacao.rastro) {
        if ((aplicacao.allData.area_demarcada_ids || []).length) {
          $scope.$emit('setActiveHeatmaps', { heatmaps: [aplicacao], mapType: 'machine' });
          return loadRastro(aplicacao)
            .then(() => renderPolylines(aplicacao.rastro.polygons));
        }

        return loadRastroByTracking(aplicacao);
      }
      $scope.$emit('setMarkers', aplicacao.startEndMarkers);
      renderPolylines(aplicacao.rastro.polygons);
    };

    $scope.hasTelemetryData = function(application) {
      const apiType = _.get($rootScope.parametros, 'integracao_gps.tipo');
      const apiKey = _.get($rootScope.parametros, 'integracao_gps.key');
      const machineGpsId = _.get(application, 'allData.atributo.maquina.integracao_gps_id');

      return apiType === 'agritel' && !!apiKey && !!machineGpsId;
    };

    $scope.telemetryUrl = function(application) {
      const apiKey = _.get($rootScope.parametros, 'integracao_gps.key');
      const machineGpsId = _.get(application, 'allData.atributo.maquina.integracao_gps_id');

      const startDate = moment(application.dt_ini).format('DD/MM/YYYY');
      const endDate = moment(application.dt_fim).format('DD/MM/YYYY');

      // eslint-disable-next-line max-len
      return `https://www.agritel.com.br/tracking/telemetry/mapview/${apiKey}/${machineGpsId}/${startDate}/to/${endDate}`;
    };

    function renderPolylines(polylines) {
      $scope.$emit('setPolylines', polylines);
      const map = LeafletService.getMap('propriedade-map');

      map.fitBounds(polylines.map(function(polyline) {
        return polyline.getBounds();
      }));

      polylines.forEach((polyline) => polyline.bindPopup(createInfoWindow(null, polyline)));
    }

    function createInfoWindow(event, polygon) {
      const content = TrackingService.getContentInfoWindow(polygon);
      return `<div class="simple-popup">
              ${content}
            </div>`;
    }

    function clearMapPolygons() {
      if (activePolygons.length > 0) {
        $scope.$emit('removePolygons', activePolygons);
        activePolygons = [];
      }
    }

    function closeApplicationsAreaVisivel() {
      $scope.applications.forEach((aplicacao) => {
        if (aplicacao.areaVisivel) {
          aplicacao.areaVisivel = false;
        }
      });
    }

    // eslint-disable-next-line max-lines-per-function
    $scope.loadWeatherChart = function(application) {
      if (!application.chart && !application.loading) {
        application.loading = true;

        const chartCfg = {
          type: 'ComboChart',
          data: {
            cols: [],
            rows: []
          },
          options: {
            width: '100%',
            legend: { position: 'none' },
            series: {
              0: {
                type: 'bars',
                targetAxisIndex: 0
              },
              1: {
                type: 'line',
                targetAxisIndex: 1
              },
              2: {
                type: 'bars'
              }
            },
            vAxes: {
              0: {
                title: 'Milímetros',
                format: '#'
              },
              1: {
                title: 'Temperatura',
                format: '#°C'
              }
            }
          }
        };

        $http.get(`${SERVER}v2/dados_meteorologicos`, {
          params: {
            type: 'estacao',
            data_inicial: application.dt_ini,
            data_final: application.dt_fim
          }
        // eslint-disable-next-line max-lines-per-function
        }).then((response) => {
          let dataArray = [
            [
              'Hora',
              'Chuva',
              'Temperatura',
              'Aplicação',
              { role: 'style' },
              { type: 'string', role: 'tooltip', p: { html: true } }
            ]
          ];

          if (response.data.length) {
            const responseData = addApplicationIntervalToData(response.data, application);
            dataArray = dataArray.concat(responseData.map(function(data, index) {
              // Pega o valor anterior para não quebrar o gráfico
              const defaultPrevious = { chuva: 0, temperatura: 0 };
              let previous = index > 0 ? responseData[index - 1] : defaultPrevious;
              if (previous.value) {
                previous = defaultPrevious;
              }

              return [
                // Data e hora do gráfico
                moment(`${data.data } ${ data.hora}`).toDate(),
                // Milímetros de chuva
                Math.round(data.chuva || previous.chuva),
                // Temperatura
                Math.round(data.temperatura || previous.temperatura),
                // Valor responsável pelas barrinhas do intervalo da aplicação
                data.value || 0,
                // Estilo da barrinha do intervalo
                'fill-opacity: 0.8; color: #551a8b;',
                // Tooltip da barrinha do intervalo
                // Impede de exibir o valor máximo de temperatura/chuva na tooltip
                // Não interfere nas outras tooltips
                data.value ? 'Intervalo da aplicação' : ''
              ];
            }));
            const last = _.last(dataArray);
            if (last[3] > 0) { // termina com uma barra de intervalo da aplicação
              // duplica o último registro com uma data maior
              dataArray.push([
                moment(last[0])
                  .add(1, 'hour')
                  .toDate(),
                last[1],
                last[2],
                0,
                last[4],
                last[5]
              ]);
            }
            const dataTable = google.visualization.arrayToDataTable(dataArray);
            chartCfg.data = dataTable;
            application.chart = chartCfg;
          }
          application.loading = false;
        });
      }
    };

    function addApplicationIntervalToData(data, application) {
      // Pega os valores de temperatura e chuva mais altos nos dados retornados
      // Precisa disso para marcar o intervalo no gráfico e manter as barrinhas
      //  sempre do tamanho máximo
      const highestTemperature = _.sortBy(data, 'temperatura').pop();
      const highestRain = _.sortBy(data, 'chuva').pop();
      const dateValue = Math.max((highestTemperature || {}).temperatura, (highestRain || {}).chuva);
      // Início e fim da aplicação
      const atributo = application.allData.atributo || {};
      const iniciadoEm = atributo.iniciado_eE|| application.dt_ini;
      const encerradoEm = atributo.encerrado_em || application.dt_fim;
      const applicationStart = moment(iniciadoEm);
      const applicationEnd = moment(encerradoEm);
      // Adiciona os dados de início e fim com o maior valor encontrado no array
      //  de dados retornados, e ordena tudo
      return data.concat(
        [applicationStart, applicationEnd].map((date) => (
          {
            data: date.format('Y-MM-DD'),
            hora: date.format('HH:mm'),
            value: dateValue
          }
        ))
      ).sort((a, b) => moment(`${a.data} ${a.hora}`) - moment(`${b.data} ${b.hora}`));
    }

    $scope.canManage = function(aplicacao) {
      const aplicacaoProcessada = aplicacao && aplicacao.situacao !== 'pendente';
      const { pulverizacao } = $rootScope.permissions;

      return pulverizacao.canManage && pulverizacao.canEditDelete && aplicacaoProcessada;
    };

    $scope.getRecommendationProducts = function(application) {
      return (application.recommendation || {}).insumos;
    };

    $scope.calculateTotalProduto = function(produto, areaGleba, shouldRecalculate = true) {
      const dose = produto.dose || produto.qt_dose;
      const quantidadeTotal = dose * areaGleba;

      if (DecimalsService.isDecimalV2Enabled()) {
        const quantidadeTotalProduto = Math.max(+produto.qt_total, 0) > 0 && !shouldRecalculate ?
          +produto.qt_total :
          quantidadeTotal;

        return DecimalsService.formatDoseOrQuantityForDisplay(quantidadeTotalProduto);
      }

      return quantidadeTotal;
    };

    $scope.$on('$destroy', clear);

    // eslint-disable-next-line complexity
    $scope.$on('$routeUpdate', function() {
      if (!$scope.applicationsFilters) {
        return;
      }

      const changedFilters =
          ((+$routeParams.activeGleba || ($scope.applicationsFilters.gleba || {}).id) &&
          +$routeParams.activeGleba !== ($scope.applicationsFilters.gleba || {}).id) ||
          ($routeParams.historyDate && $routeParams.historyDate !== $scope.applicationsFilters.dataInicial);

      if (changedFilters) {
        initializeVariables();
        setValoresComBaseNoHistorico();
        $scope.getApplications();
      }

      if ($routeParams.activeApplicationsTab !== 'pulverizacao' && activePolygons.length > 0) {
        clear();
      }
    });
  });
